import React from "react";
import { useTranslation } from "react-i18next";
import TeamIcon from "@components/icons/TeamIcon";
import { CompetitionAverage } from "@data-types/sport-stats/SportStatsTypes";
import { Team, Tournament } from "@gp/models";

export const CompetitionAverages = (props: {
	title: string;
	data: CompetitionAverage[];
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) => {
	if (!props.data) return null;

	const { t } = useTranslation();

	return (
		<div className="card card--raised card--stats">
			<div className="card__header card--stats__header">
				<div className="card__title card__title--base card--stats__heading">
					{props.title}
				</div>
			</div>

			<div className="card--stats__body">
				<div className="card--stats__row">
					<div className="card--stats__col card--stats__col--left">
						<TeamIcon
                            showCountryFlag={props.tournament?.showCountryFlag}
                            flagCode={props.homeTeam?.countryCode}
                            jerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
                            opponentFlagCode={props.awayTeam?.countryCode}
                            opponentJerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
                            className="u-icon u-icon--base u-mar--right--3"
                        />
						<div className="card--stats__value">
							{t("EVENT.OFFER.COMPETITOR_HOME")}
						</div>
					</div>
					<div className="card--stats__col card--stats__col--right">
						<div className="card--stats__value">
							{t("EVENT.OFFER.COMPETITOR_AWAY")}
						</div>
						<TeamIcon
                            showCountryFlag={props.tournament?.showCountryFlag}
                            flagCode={props.awayTeam?.countryCode}
                            jerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
                            opponentFlagCode={props.homeTeam?.countryCode}
                            opponentJerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
                            className="u-icon u-icon--base u-mar--left--3"
                        />
					</div>
				</div>

				{props.data.map((item, index) => (
					<div
						key={`${index}`}
						className="card--stats__row"
					>
						<div className="card--stats__col card--stats__col--left">
							<div className="card--stats__value">
								{item.home ?? "0"}
							</div>
						</div>
						<div className="card--stats__col card--stats__col--middle">
							<div className="card--stats__label">
								{t(
									`EVENT.STATISTICS.STREAK_STATS.${item.abrv}`)}
							</div>
						</div>
						<div className="card--stats__col card--stats__col--right">
							<div className="card--stats__value">
								{item.away ?? "0"}
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
